import React, { useState, useEffect } from 'react';
import api from '../../services/api';

const BlackBar = () => {
  const [settings, setSettings] = useState({
    announcementBarEnabled: true,
    announcementBarText: 'ONLINE EXCLUSIVE SALE IS LIVE NOW',
    announcementBarColor: '#000000'
  });

  useEffect(() => {
    const fetchSettings = async () => {
      try {
        const res = await api.get('/settings/announcement');
        setSettings({
          announcementBarEnabled: res.announcementBarEnabled !== undefined ? res.announcementBarEnabled : true,
          announcementBarText: res.announcementBarText || 'ONLINE EXCLUSIVE SALE IS LIVE NOW',
          announcementBarColor: res.announcementBarColor || '#000000'
        });
      } catch (err) {
        console.error('Failed to fetch announcement bar settings');
      }
    };
    fetchSettings();
  }, []);

  if (!settings.announcementBarEnabled) return null;

  return (
    <div className="black-bar" style={{ backgroundColor: settings.announcementBarColor }}>
      <div className="container">
        {settings.announcementBarText}
      </div>
    </div>
  );
};

export default BlackBar;